import React from "react";
import { sanitizeUrl } from "../sanitize";

const ButtonBlock = {
  label: "Button",
  fields: {
    label: {
      type: "text",
      placeholder: "Button text...",
      contentEditable: true,
    },
    href: { type: "text" },
    variant: {
      type: "radio",
      options: [
        { label: "primary", value: "primary" },
        { label: "secondary", value: "secondary" },
      ],
    },
  },
  defaultProps: {
    label: "Button",
    href: "#",
    variant: "primary",
  },
  render: ({ href, variant, label, puck }) => {
    const base =
      "inline-block px-5 py-2 rounded font-medium transition";

    const styles =
      variant === "secondary"
        ? "bg-gray-200 text-black hover:bg-gray-300"
        : "bg-blue-600 text-white hover:bg-blue-700";

    return (
      <a target="blank"
        href={puck?.isEditing ? "#" : sanitizeUrl(href)}
        className={`${base} ${styles}`}
        tabIndex={puck?.isEditing ? -1 : undefined}
      >
        {label || "Button"}
      </a>
    );
  },
};

export default ButtonBlock;
